import { createScheduleComponent } from '@play-co/components';

/** Available particle effects for puzzle backgrounds */
export type BackgroundEffect = 'snow' | 'sakura' | 'leaf' | 'rain';

/** Background metadata including image and optional particle effect */
export type Match2BackgroundMetadata = {
  /** Background filename (e.g., 'BG_summer.png') */
  image: string;
  /** Optional particle effect to display over the background */
  effect?: BackgroundEffect;
};

/**
 * Monthly background schedule for match2 puzzle.
 * Used as fallback when no gacha event has a puzzleBackground defined.
 * Uses yearly schedule to automatically repeat every year.
 *
 * Schedule:
 * - January: BG_january_newyear2026.png (New Year) + snow
 * - February: BG_winter.png (Winter) + snow
 * - March: BG_teamountain.png (Tea Mountain)
 * - April: BG_sakura.ver.png (Sakura) + sakura
 * - May: BG_may_childrensday.png (Children's Day)
 * - June: BG_june_rain.png (Rainy Season)
 * - July: BG_summer.png (Summer)
 * - August: BG_summer.png (Summer)
 * - September: BG_summerfestival.png (Summer Festival)
 * - October: BG_autumn.png (Autumn)
 * - November: BG_autumnleaves.png (Autumn) + leaf
 * - December: BG_xmas.png (Christmas) + snow
 */
export const seasonalBackgroundSchedule =
  createScheduleComponent<Match2BackgroundMetadata>(
    '2026-01-01',
    'Asia/Tokyo',
    {
      yearly: [
        {
          date: 1,
          month: 'January',
          time: '00:00',
          duration: { days: 31 },
          metadata: {
            image: 'BG_january_newyear2026.png',
            effect: 'snow',
          },
        },
        {
          date: 1,
          month: 'February',
          time: '00:00',
          duration: { months: 1 },
          metadata: { image: 'BG_winter.png', effect: 'snow' },
        },
        {
          date: 1,
          month: 'March',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_teamountain.png' },
        },
        {
          date: 1,
          month: 'April',
          time: '00:00',
          duration: { days: 30 },
          metadata: { image: 'BG_sakura.ver.png', effect: 'sakura' },
        },
        {
          date: 1,
          month: 'May',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_may_childrensday.png' },
        },
        {
          date: 1,
          month: 'June',
          time: '00:00',
          duration: { days: 30 },
          metadata: { image: 'BG_june_rain.png' },
        },
        {
          date: 1,
          month: 'July',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_summer.png' },
        },
        {
          date: 1,
          month: 'August',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_summer.png' },
        },
        {
          date: 1,
          month: 'September',
          time: '00:00',
          duration: { days: 30 },
          metadata: { image: 'BG_summerfestival.png' },
        },
        {
          date: 1,
          month: 'October',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_autumn.png' },
        },
        {
          date: 1,
          month: 'November',
          time: '00:00',
          duration: { days: 30 },
          metadata: { image: 'BG_autumnleaves.png', effect: 'leaf' },
        },
        {
          date: 1,
          month: 'December',
          time: '00:00',
          duration: { days: 31 },
          metadata: { image: 'BG_xmas.png', effect: 'snow' },
        },
      ],
    },
  );
